import { DateTime } from 'luxon'

export function fromSQL(value: string, format = 'dd/MM/yyyy HH:mm:ss') {
  const date = DateTime.fromSQL(value)

  if (!date.isValid) return '--'

  return date.toFormat(format)
}
